var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9375 2C5.80715 2 5.75 2.09321 5.75 2.15V3.45C5.75 3.50679 5.80715 3.6 5.9375 3.6H10.0625C10.1928 3.6 10.25 3.50679 10.25 3.45V2.15C10.25 2.09321 10.1928 2 10.0625 2H5.9375ZM11.25 2.3V2.15C11.25 1.48882 10.6915 1 10.0625 1H5.9375C5.30846 1 4.75 1.48882 4.75 2.15V2.3H3.875C3.38649 2.3 2.91273 2.48321 2.55922 2.81744C2.20476 3.15256 2 3.61327 2 4.1V13.2C2 13.6867 2.20476 14.1474 2.55922 14.4826C2.91273 14.8168 3.38649 15 3.875 15H12.125C12.6135 15 13.0873 14.8168 13.4408 14.4826C13.7952 14.1474 14 13.6867 14 13.2V4.1C14 3.61327 13.7952 3.15256 13.4408 2.81744C13.0873 2.48321 12.6135 2.3 12.125 2.3H11.25ZM11.25 3.3V3.45C11.25 4.11118 10.6915 4.6 10.0625 4.6H5.9375C5.30846 4.6 4.75 4.11118 4.75 3.45V3.3H3.875C3.63417 3.3 3.40845 3.39071 3.24623 3.54408C3.08497 3.69656 3 3.89716 3 4.1V13.2C3 13.4028 3.08497 13.6034 3.24623 13.7559C3.40845 13.9093 3.63417 14 3.875 14H12.125C12.3658 14 12.5915 13.9093 12.7538 13.7559C12.915 13.6034 13 13.4028 13 13.2V4.1C13 3.89716 12.915 3.69656 12.7538 3.54408C12.5915 3.39071 12.3658 3.3 12.125 3.3H11.25Z",
    fill: "#202442"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.006b513ea5f7476570347f4a5f8904bf.svg";
export { ForwardRef as ReactComponent };